import { Component, Input } from '@angular/core'

@Component({
    selector: 'ca-subject-user-badge',
    template: `
        <span
            *ngIf="showCaUserIcon()"
            class="fa ci ci-ca-badge"
            title="Tento subjekt používá aplikaci CleverAssets">
        </span>
    `,
    standalone: false
})
export class SubjectUserBadgeComponent {
    @Input() subjects: any

    showCaUserIcon(): boolean {
        // Make sure subjects is always array of subjects, even if it is just one subject
        if (!Array.isArray(this.subjects)) {
            this.subjects = [this.subjects]
        }

        return this.subjects.some((subject) => {
            return this.isVisibleCaUser(subject) && !subject.isConcerned
        })
    }

    private isVisibleCaUser(subject): boolean {
        // TODO: check whether subject agreed to be visible to other users with icon
        if (subject) {
            return subject.publiclyVisibleCaUser
        }
    }
}
